import Bedroom from './roomTypes/bedroom';
import Bathroom from './roomTypes/bathroom';
import Entry from './roomTypes/entry';
import Kitchen from './roomTypes/kitchen';
import SmallKitchen from './roomTypes/smallkitchen';
import Livingroom from './roomTypes/livingroom';
import Outside from './roomTypes/outside';
import Balcony from './roomTypes/balcony';
import Storage from './roomTypes/storage';
import Washroom from './roomTypes/washroom';
import Office from './roomTypes/office';
import Atelier from './roomTypes/atelier';

const ROOMTYPES = {
  Bathroom,
  Balcony,
  Storage,
  Entry,
  Kitchen,
  SmallKitchen,
  Washroom,
  Bedroom,
  Livingroom,
  Outside,
  Office,
  Atelier
};
/*
RoomTypes["bedroom"] = ;
RoomTypes["basement"] = "Kjeller";
RoomTypes["bath"] = "Bad";
RoomTypes["balcony"] = "Balkong";
RoomTypes["corridor"] = "Gang";
RoomTypes["entry"] = "Entre";
RoomTypes["garage"] = "Garasje";
RoomTypes["kitchen"] = "Kjøkken";
RoomTypes["laundry"] = "Vaskerom";
RoomTypes["livingroom"] = "Stue";
RoomTypes["storage"] = "Bod";
RoomTypes["office"] = "Kontor";
RoomTypes["toilet"] = "Toalett";
RoomTypes["terrace"] = "Terrasse";*/

export default ROOMTYPES;